/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promos_AddInputs */



/**
* | output |
* | --- |
* | "Add promo" |
*
* @param {Promos_AddInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_add = /** @type {((inputs?: Promos_AddInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_AddInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter une promo")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir promo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionar promo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi promo")
	return /** @type {LocalizedString} */ ("Add promo")
});